import React from 'react';
import Box from "@mui/material/Box";

import SearchFilter from "./SearchFilter/SearchFilter";
import FilterList from "./FilterList/FilterList";

const Filter = () => {
    return (
        <Box>
            <SearchFilter/>
            <FilterList/>
        </Box>
    );
};

export default Filter;